export const SUCCESS_SUFFIX = '_SUCCESS';
export const FAILURE_SUFFIX = '_FAILURE';
export const ABORT_SUFFIX = '_ABORT';
export const REQUEST_SUFFIX = '_REQUEST';
